"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bookmark = void 0;
const lodash_1 = require("lodash");
const common_1 = require("../common");
const BookmarkUpdateData_1 = require("./BookmarkUpdateData");
var Bookmark;
(function (Bookmark) {
    Bookmark.excludedComparisonPaths = ['createdAt', 'modifiedAt', 'migratedAt'];
    function createId(assignmentId, userId) {
        return `${assignmentId}-${userId}`;
    }
    Bookmark.createId = createId;
    function create(data, userId, creationDate, schedulable) {
        const { meta, settings } = data;
        const now = creationDate || Date.now();
        return {
            _id: createId(meta._id, userId),
            type: data.meta.type,
            groupId: data.meta.groupId,
            module: data.meta.module,
            order: data.meta.order,
            userId,
            createdAt: now,
            modifiedAt: now,
            assignmentId: meta._id,
            assignmentInfo: meta.assignmentInfo,
            progress: {
                done: 0,
                percent: 0,
                total: meta.assignmentInfo.numberOfPins,
            },
            seenAt: undefined,
            isHidden: settings.type === 'realtime',
            testPhase: settings.type === 'test' ? 'created' : undefined,
            grade: undefined,
            lockStudent: settings.type === 'test' ? settings.lockStudents : undefined,
            isLinear: 'isLinear' in settings && settings.isLinear,
            ...schedulable,
        };
    }
    Bookmark.create = create;
    /** creates an in memory copy with the updated changes so we can use it for comprison */
    function update(bookmark, updates) {
        const cloned = (0, lodash_1.cloneDeep)(bookmark);
        const updateFields = BookmarkUpdateData_1.BookmarkUpdateData.updateFields(updates);
        (0, lodash_1.forEach)(updateFields, (value, field) => (0, lodash_1.set)(cloned, field, value));
        return cloned;
    }
    Bookmark.update = update;
    function isNew(bookmark) {
        const hasProgress = bookmark.progress && bookmark.progress.percent > 0;
        return (0, lodash_1.isNil)(bookmark.seenAt) && !hasProgress;
    }
    Bookmark.isNew = isNew;
    function isTest(bookmark) {
        return bookmark.type === 'test';
    }
    Bookmark.isTest = isTest;
    function orderedByCreationDate(bookmarks) {
        return (0, lodash_1.orderBy)(bookmarks, (t) => t.createdAt, 'desc');
    }
    Bookmark.orderedByCreationDate = orderedByCreationDate;
    function latestDate(bookmarks) {
        const bookmark = (0, lodash_1.first)(Bookmark.orderedByCreationDate(bookmarks));
        return bookmark && new Date(bookmark.createdAt);
    }
    Bookmark.latestDate = latestDate;
    function isActiveTest(bookmark) {
        return common_1.TestPhase.isLive(bookmark.testPhase);
    }
    Bookmark.isActiveTest = isActiveTest;
    function isAccessible(bookmark) {
        return (0, lodash_1.isNil)(bookmark.testPhase) || bookmark.testPhase !== 'closed';
    }
    Bookmark.isAccessible = isAccessible;
    function isLockedByOtherBookmarks(bookmark, lockedBookmarks) {
        // bookmark can not lock itself
        if (lockedBookmarks.find((b) => b._id === bookmark._id)) {
            return false;
        }
        // we can only lock by subject
        if ((0, lodash_1.isEmpty)(bookmark.assignmentInfo.subject)) {
            return false;
        }
        return (0, lodash_1.some)(lockedBookmarks, (lockedBookmark) => lockedBookmark.lockStudent &&
            lockedBookmark.assignmentInfo.ownerId === bookmark.assignmentInfo.ownerId &&
            lockedBookmark.assignmentInfo.subject === bookmark.assignmentInfo.subject);
    }
    Bookmark.isLockedByOtherBookmarks = isLockedByOtherBookmarks;
})(Bookmark || (exports.Bookmark = Bookmark = {}));
//# sourceMappingURL=Bookmark.js.map